<template>
    <div class="cgs-app-myprocess">
        <div class="cgs-app-myprocess-header">
            <van-nav-bar :border="true" :title="pageTitle">
                <template #left>
                    <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
                </template>
            </van-nav-bar>
        </div>
        <keep-alive>
            <router-view class="cgs-app-myprocess-content" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
        <van-tabbar v-model="active" :placeholder="true" route>
            <van-tabbar-item v-for="item in tabbarList" :key="item.name" :name="item.name" replace :to="item.to"
                :badge="item.badge === 0 ? '' : item.badge">
                <span>{{ item.label }}</span>
                <template #icon>
                    <span class="iconfont" :class="item.icon"></span>
                </template>
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import {
    Tabbar,
    TabbarItem,
    Dialog,
    Button,
    NavBar,
    PullRefresh
} from "vant";
import {
    getTaskCount
} from "@/api/myProcess"

export default {
    components: {
        vanNavBar: NavBar,
        vanTabbar: Tabbar,
        vanTabbarItem: TabbarItem,
        vanButton: Button
    },
    data() {
        return {
            loading: false,
            active: 'todo',
            tabbarList: [{
                to: "/myprocess/todo",
                name: "todo",
                label: "待办",
                icon: "cgsIcon-wodedaiban",
                badge: "",
            },
            {
                to: "/myprocess/faqi",
                name: "faqi",
                label: "我发起的",
                icon: "cgsIcon-faqi",
                badge: "",
            },
            {
                to: "/myprocess/completed",
                name: "completed",
                label: "已完成",
                icon: "cgsIcon-zhengque",
                badge: "",
            }
            ]
        }
    },
    created() {
        this.init()
        this.$ws.on("send_notice", async (data) => {
            this.init()
        });
        this.$ws.on("clear_notice", async (data) => {
            this.init()
        });
    },
    computed: {
        pageTitle: {
            get() {
                let _title = ''
                let _tabbar = this.tabbarList.find(_item => _item.name === this.active)
                _title = _tabbar.label
                return _title
            },
            set() { }
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        async init() {
            this.loading = true
            try {
                let countResult = await getTaskCount()
                if (countResult.code === 200) {
                    let _countObj = countResult.data
                    this.tabbarList[1].badge = _countObj['0']
                    this.tabbarList[0].badge = _countObj['1']

                }
                this.loading = false
            } catch (err) {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.cgs-app-myprocess {
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
}

.cgs-app-myprocess-content {
    flex: 1;
    overflow-y: auto;
    padding-top: 10px;
}

.myprocess-cgsFormList {
    flex: 1;
    padding-top: 10px;
}
</style>